module.exports = __webpack_public_path__ + "a7931e9d6d728f43f8ea1ca89663dc5c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-13.png
// module id = 1593
// module chunks = 0